// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"56092429","171":"a956a45a","302":"6319c8ed","393":"b0e6d9a8","453":"94315750","456":"4bf92b8c","507":"1581e059","960":"88f0021a","968":"87839a17"}[chunkId] + ".chunk.js";
};